var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7998 5.59595C2.7998 5.37755 2.9818 5.19995 3.2014 5.19995H20.7982C21.0202 5.19995 21.1998 5.38035 21.1998 5.59595V7.20395C21.1998 7.42235 21.0178 7.59995 20.7982 7.59995H3.2014C2.9816 7.60041 2.80244 7.42374 2.7998 7.20395V5.59595ZM2.8 11.196C2.8 10.9776 2.982 10.8 3.2016 10.8H20.7984C21.0204 10.8 21.2 10.9804 21.2 11.196V12.804C21.2 13.0224 21.018 13.2 20.7984 13.2H3.2016C2.98179 13.2005 2.80263 13.0238 2.8 12.804V11.196ZM3.1992 16.4C2.9788 16.4 2.8 16.5776 2.8 16.796V18.404C2.80219 18.623 2.98015 18.7996 3.1992 18.8H14.4008C14.6212 18.8 14.8 18.6224 14.8 18.404V16.796C14.7978 16.577 14.6199 16.4004 14.4008 16.4H3.1992Z",
    fill: "#3BA0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxIcon);
export default __webpack_public_path__ + "static/media/docx-icon.870e85fd.svg";
export { ForwardRef as ReactComponent };